import {printSurveyParticipantsAndDate} from "./printSurveyParticipantsAndDate";
import {checkResultLine} from "../utils/checkResultLine";
export function displaySurveyResult(container, surveyAnswers, givenAnswers) {
    container.addClass('survey_result');
    container.closest('.survey_entry').addClass('survey_entry_result');
    container.find(".timeline_entry_footer").remove();
    container.find("a.post_survey").remove();
    container.find(".js-entry-header").remove();
    container.find(".answer-explanation").remove();
    container.find(".answers").remove();
    container.find(".js-survey-result").append("<div class='answers result'></div>");
    var answers = {};
    $.each(surveyAnswers, function (key, answer) {
        if (key !== "posted_answers") {
            answers[answer.csa_id] = 0;
        }
    });
    if (givenAnswers.length > 0) {
        $.each(givenAnswers, function (key, answer) {
            answers[answer.community_survey_answer_id]++;
        });
    }

    $.each(surveyAnswers, function (key, answer) {
        if (key !== "posted_answers") {
            var totalAnswers = givenAnswers.length;
            var percentage = 0;
            if (totalAnswers > 0) {
                percentage = answers[answer.csa_id] / totalAnswers * 100;
            }
            var csa_class = "";
            var csa_image = "";
            if (answer.csa_image !== undefined && answer.csa_image !== "" && answer.csa_image !== null) {
                csa_image = "<div class='result_image' style='background-image:url(/userdata/survey/resize/" + answer.csa_image + ")'></div>";
                csa_class = "imageCheckboxen";
            }
            var result = "<div class='" + csa_class + "'><div class='result_percent'>" + Math.floor(percentage) + "%</div>" + csa_image + "<div class='result_line'><div class='result_line_active' data-width='" + Math.floor(percentage) + "%'></div>" + answer.csa_description + "</div></div>";
            container.find(".answers").append(result);
            setTimeout(function () {
                checkResultLine();
            }, 200);
        }
    });
    printSurveyParticipantsAndDate(surveyAnswers[0], container, givenAnswers.length);
}
